module.exports = __webpack_public_path__ + "static/media/twigsAndLight.f2b25c5d.jpg";